import type { UserDTO } from '@/entities/user'
import { baseApi, customErrorHandler } from '@/shared/api'

export const xeroAuthApi = baseApi.injectEndpoints({
	endpoints: (build) => ({
		initXeroAuth: build.mutation<
			{ authorizationUrl: string },
			{ invitationToken?: string }
		>({
			query: (body) => ({
				url: '/xero-auth/init-xero-auth',
				method: 'POST',
				body,
				responseHandler: 'text'
			}),
			transformResponse: (response: string) => ({
				authorizationUrl: response
			}),
			transformErrorResponse: customErrorHandler
		}),
		xeroCallback: build.query<UserDTO, { code: string; state: string }>({
			query: ({ code, state }) => ({
				url: '/xero-auth/xero-callback',
				method: 'GET',
				params: { code, state }
			}),
			transformErrorResponse: customErrorHandler
		})
	})
})

export const { useInitXeroAuthMutation } = xeroAuthApi
